import { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';

import Modal from 'shared/Modal';
import Button from 'shared/Button';

import formClasses from 'shared/Forms/Forms.module.scss';

const DEFAULT_PASSWORD = 'RepdNYC';

export default function LockScreen({
  visible,
  clientId,
  toggle,
}: {
  clientId?: string;
  visible: boolean;
  toggle: Function | any;
}) {
  const [password, setPassword] = useState('')

  const updateFormPassword = (e: any) => { setPassword(e.target.value) }
  const handleSubmit = (event: any) => {
    if (event) event.preventDefault()

    if (password === DEFAULT_PASSWORD)
      toggle(false)
    else
      toast.error("Please enter a valid password")

    localStorage.setItem(`lockScreenEntered${clientId}`, 'true');
  }

  return (
    <Modal visible={visible} toggle={toggle}>
      <div className={formClasses.Form}>
        <form action="#" method="#" onSubmit={handleSubmit}>
          <h4> <strong>Password Protected</strong> </h4>

          <div className={formClasses.InputWithLabel}>
            <label htmlFor="password"> Password </label>

            <input type="password" name="password" onChange={updateFormPassword} />
          </div>
        </form>

        <div className={formClasses.buttonGroup}>
          <Button
            customClass={formClasses.primary}
            callback={handleSubmit}
            text="Ok"
          />
        </div>

        <ToastContainer position="top-center" />
      </div>
    </Modal>
  );
}
